import { TitleTableProps } from "../components/table-pagination-sorting/interfaces/interfaces";

export const initialBanco = {
  id: '',
  nombre: '',
  /* codigo: '', */
  estado: 1,
}
export type propsBanco = typeof initialBanco;

export const initialRutas = {
  id: 0,
  id_planta: 0,
  codigo: '',
  nombre: '',
  descripcion: '',
  estado: 1
}
export type propsRutas = typeof initialRutas;

export const initialCupo = {
  id: 0,
  id_planta: 0,
  id_ruta: 0,
  codigo: '',
  estado: 1
}
export type propsCupo = typeof initialCupo;

export const initialConductor = {
  id: 0,
  id_planta: 0,
  id_ruta: 0,
  tipo_pago: 'PL',
  pago_litros: 0,
  pago_fijo: 0,
  forma_pago: '',
  id_banco: 0,
  nombre_cuenta: '',
  tipo_cuenta: '',
  cedula: '',
  primer_nombre: '',
  segundo_nombre: '',
  primer_apellido: '',
  segundo_apellido: '',
  estado: true,
  dv: '',
  correo: '',
  enviar_comprobante: 0
}
export type propsConductor = typeof initialConductor;

export const initialProveedores = {
  id: 0,
  id_planta: 0,
  id_ruta: 0,
  id_cupo: 0,
  cedula: '',
  primer_nombre: '',
  segundo_nombre: '',
  primer_apellido: '',
  segundo_apellido: '',
  precio_litro: 0,
  forma_pago: '',
  nombre_cuenta: '',
  tipo_cuenta: '',
  id_banco: 0,
  estado: 1,
  dv: '',
  telefono: '',
  correo: '',
  enviar_comprobante: 0
}
export type propsProveedores = typeof initialProveedores;

export const initialPlantas = {
  id: 0,
  nombre: '',
  estado: true
}
export type propsPlantas = typeof initialPlantas;

export const initialPeso = {
  id: 0,
  id_usuario: 0,
  id_proveedor: 0,
  id_conductor: 0,
  id_planta: '',
  id_tina: '',
  id_cupo: '',
  fecha: '',
  peso_entrada_lts: 0.0,
  peso_salida_lts: 0.0,
  tipo_estado: 0,
  cantidad: '',
  comentario: '',
}

export type propsPeso = typeof initialPeso;

export const initialTinas = {
  id: 0,
  nombre_tina: '',
  descripcion: '',
  capacidad:'',
  estado: true
}
export type propsTinas = typeof initialTinas;



export const initialElement = {
  id: 0,
  nombre: '',
  unidad_medida: '',
  estado: true
}
export type propsElementoFabrica = typeof initialElement;

export const initialFabricacion = {
  id: 0,
  fecha_registro: '',
  datos_receta: [] as {
    fabricacion_id: number;
    receta_id: number;
    cantidad_producida: number;
    unidad_medida_producto: string;
  }[],
  datos_materiales: [] as {
    extraccion_id: number;
    material_id: number;
    cantidad: string;
  }[],
  comentario: '',
  fabricaReceta: [] as {
    id: number;
    fabricacion_id: number;
    receta_id: number;
    extraccion_id: number;
    cantidad_producida: number;
    unidad_medida_producto: string;
    id_lote: string;
    receta: {
      id: number;
      receta: string;
    };
    extraccion: {
      id: number;
      extraccionMat: {
        id: number;
        extraccion_id: number;
        material_id: number;
        cantidad: string;
        materialExt: {
          id: number;
          nombre: string;
        };
      }[];
    };
  }[],
  estado: true
};

export type propsFabricacion = typeof initialFabricacion;

export const initialRecipe= {
  id: 0,
  receta: '',
  recetaMaterial: [] as { material_id: number }[],
  descripcion: '',
  estado: true
}
export type propsRecipe = typeof initialRecipe;

export interface tablePaginationRs {
  rows: Array<{ [key: string]: any }>;
  count: number
}

export interface tableComponentComplet extends tablePaginationRs {
  info: any;
  titles: Array<TitleTableProps>;
}
